module.exports = __webpack_public_path__ + "static/Roostr3-ea38baaacd9e204d847e627528eb8f12.png";